export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10366.8b26257b.jpg";